import { buildCollection, buildProperty } from "@firecms/core";

export type AppConfig = {
  id?: string;
  header_hero_list: HeaderHero[];
};

export type HeaderHero = {
  image_path: string;
  call_to_action: string;
};

export const appConfigCollection = buildCollection({
  id: "app_config",
  name: "App Config",
  path: "app_config",
  icon: "settings",
  group: "App Game",
  textSearchEnabled: true,
  properties: {
    header_hero_list: {
      name: "Header Heroes",
      dataType: "array",
      of: {
        dataType: "map",
        properties: {
          image_path: {
            dataType: "string",
            name: "Image Path",
            storage: {
              storagePath: "images",
              acceptedFiles: ["image/*"],
              maxSize: 1 * 1024 * 1024,
            },
            validation: {
              required: true,
            },
          },
          call_to_action: {
            dataType: "string",
            name: "Call to Action",
            validation: {
              required: true,
            },
          },
        },
      },
      defaultValue: ["es"],
    },
  },
});
